import { Outlet, NavLink, Link } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { DarkModeToggle } from './components/DarkModeToggle'
import { useWireAuth } from './auth/useWireAuth'

function AdminLayout() {
  const { user, logout } = useWireAuth()
  const displayName = user?.given_name ?? user?.name ?? user?.email ?? null
  return (
    <div className="min-h-screen bg-canvas text-fg">
      <header className="sticky top-0 z-50 flex h-12 items-center gap-6 border-b border-line bg-surface px-6">
        <Link to="/admin" className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-fg-secondary transition-colors hover:text-fg">
          <svg xmlns="http://www.w3.org/2000/svg" width="125.409" height="98.041" viewBox="0 0 125.409 98.041" fill="currentColor" aria-hidden="true" className="h-3.5 w-auto">
            <path d="M0,0,48.06,98.041,64.4,69.206,30.278,0Z" />
            <path d="M40.35,0,88.409,98.041,104.75,69.206,70.627,0Z" />
            <path d="M80.762,0.005l31.149,63,13.5-23.818L106.434,0.005Z" />
          </svg>
          Admin
        </Link>
        <div className="h-4 w-px bg-line-subtle" aria-hidden="true" />
        <nav className="flex items-center gap-3">
          <AdminNavLink to="/admin/layouts">Layout Studio</AdminNavLink>
          <span className="text-line-strong" aria-hidden="true">·</span>
          <AdminNavLink to="/admin/pages">Production Desk</AdminNavLink>
          <span className="text-line-strong" aria-hidden="true">·</span>
          <AdminNavLink to="/admin/articles">Copy Desk</AdminNavLink>
          <div className="mx-1 h-4 w-px bg-line-subtle" aria-hidden="true" />
          <AdminNavLink to="/admin/metrics">Metrics</AdminNavLink>
          <span className="text-line-strong" aria-hidden="true">·</span>
          <AdminNavLink to="/admin/design-guide">Design Guide</AdminNavLink>
          <span className="text-line-strong" aria-hidden="true">·</span>
          <AdminNavLink to="/admin/dev-status">Dev Status</AdminNavLink>
        </nav>
        <div className="ml-auto flex items-center gap-3">
          <DarkModeToggle className="flex h-7 w-7 items-center justify-center rounded-full bg-fill text-fg hover:bg-fill-hover" />
          <AdminNavLink to="/wire">
            <span className="flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="125.409" height="98.041" viewBox="0 0 125.409 98.041" fill="currentColor" aria-hidden="true" className="h-3 w-auto">
                <path d="M0,0,48.06,98.041,64.4,69.206,30.278,0Z" />
                <path d="M40.35,0,88.409,98.041,104.75,69.206,70.627,0Z" />
                <path d="M80.762,0.005l31.149,63,13.5-23.818L106.434,0.005Z" />
              </svg>
              Front Page
            </span>
          </AdminNavLink>
          <div className="h-4 w-px bg-line-subtle" aria-hidden="true" />
          {displayName && (
            <span className="text-xs text-fg-secondary">{displayName}</span>
          )}
          <button
            onClick={logout}
            title="Sign out"
            aria-label="Sign out"
            className="flex items-center gap-1 rounded px-2 py-1 text-xs text-fg-secondary hover:bg-fill hover:text-fg transition-colors"
          >
            <LogOut size={12} aria-hidden="true" />
            Sign out
          </button>
        </div>
      </header>
      <Outlet />
    </div>
  )
}

function AdminNavLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `text-xs font-semibold uppercase tracking-widest transition-colors ${
          isActive ? 'text-fg' : 'text-fg-secondary hover:text-fg'
        }`
      }
    >
      {children}
    </NavLink>
  )
}

export default AdminLayout
